// Feature Flags Configuration
const FEATURE_FLAGS = {
  // Authentication features
  ENABLE_LOGIN: process.env.REACT_APP_ENABLE_LOGIN === 'true',
  ENABLE_REGISTRATION: process.env.REACT_APP_ENABLE_REGISTRATION === 'true',
  ENABLE_PATIENT_LOGIN: process.env.REACT_APP_ENABLE_PATIENT_LOGIN === 'true',
  
  // Dashboard features
  ENABLE_DASHBOARD: process.env.REACT_APP_ENABLE_DASHBOARD === 'true',
  
  // EHR/FHIR Integration - Set to 'true' to enable, 'false' or undefined to show "Coming Soon"
  ENABLE_EHR_INTEGRATION: process.env.REACT_APP_ENABLE_EHR_INTEGRATION === 'true',
  
  // Coming soon messaging
  SHOW_COMING_SOON: process.env.REACT_APP_SHOW_COMING_SOON === 'true'
};

export const isFeatureEnabled = (featureName) => {
  return FEATURE_FLAGS[featureName] || false;
};

export const getFeatureFlags = () => {
  return { ...FEATURE_FLAGS };
};

// Coming soon configuration
export const COMING_SOON_CONFIG = {
  message: "We're launching soon! Sign up to be notified when Patientree goes live.",
  ctaText: "Get Notified",
  emailPlaceholder: "Enter your email address",
  successMessage: "Thanks! We'll notify you when we launch.",
  estimatedLaunch: "Q4 2025", // Update this as needed
  features: [
    "Patient Management",
    "Appointment Scheduling", 
    "Billing & Payments",
    "Staff Management",
    "Analytics & Reporting"
  ]
}; 